// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Start Message  */

.message-section{
    margin: 10px 0px;
    padding: 5px ;
}

.message-section .all-message-cards{
    width: 850px;
    max-width: 100%;
    /* background-color: white; */
    border-radius: 6px;
    height: 86vh;
    overflow-y: scroll;
    padding: 10px 18px;
}

.message-section .all-message-cards .message-head,
.message-section .all-message-cards .message-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border-radius: 7px;
    margin-bottom: 10px;
    padding: 13px 15px;
}

.message-section .all-message-cards .message-head .cell{
    font-weight: 700;
}

.message-section .all-message-cards .message-head .cell ,
.message-section .all-message-cards .message-body .cell{
    width: 20%;
    background-color: white;
    border-radius: 6px;
    cursor: pointer;
}

.message-section .all-message-cards .message-body .cell img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
}

.message-section .all-message-cards .search-tools{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 13px ;
}

.message-section .all-message-cards .search-tools .search-bar{
    background-color: white;
    width: 280px;
    border-radius: 23px;
    padding: 5px 10px;
}

.message-section .all-message-cards .search-tools .search-bar svg{
    color: var(--gray-color); 

}

.message-section .all-message-cards .search-tools .search-bar input{
    border: none;
    width: 210px;
    margin-left: 8px;
}
.message-section .all-message-cards .search-tools .search-bar input:focus{
    outline: none;
}

.message-section .all-message-cards .search-tools .btn-send{
    font-weight: bold;
    color: white;
    background-color: var(--main-color);
    border: none;
    border-radius: 5px;
    padding: 12px 18px;
    cursor: pointer;
    display: block;
    font-size: 12px;
    transition: var(--main-transition);
}

.message-section .all-message-cards .search-tools .btn-send:hover{
    opacity: .8;
}

.message-section .main-pagination{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.message-section .main-pagination .pagination-btn{
    width: 100px;
    margin: 10px 0px;
}

.message-section .main-pagination .pagination-btn button{
    color: white;
    background-color: var(--main-color); 
    border-radius: 22px;
    padding: 10px 22px;
    border: none;
}


/* End Message */`, "",{"version":3,"sources":["webpack://./src/Pages/MessagesPage/messages.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA,gBAAgB","sourcesContent":["/* Start Message  */\n\n.message-section{\n    margin: 10px 0px;\n    padding: 5px ;\n}\n\n.message-section .all-message-cards{\n    width: 850px;\n    max-width: 100%;\n    /* background-color: white; */\n    border-radius: 6px;\n    height: 86vh;\n    overflow-y: scroll;\n    padding: 10px 18px;\n}\n\n.message-section .all-message-cards .message-head,\n.message-section .all-message-cards .message-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: white;\n    border-radius: 7px;\n    margin-bottom: 10px;\n    padding: 13px 15px;\n}\n\n.message-section .all-message-cards .message-head .cell{\n    font-weight: 700;\n}\n\n.message-section .all-message-cards .message-head .cell ,\n.message-section .all-message-cards .message-body .cell{\n    width: 20%;\n    background-color: white;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.message-section .all-message-cards .message-body .cell img {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n}\n\n.message-section .all-message-cards .search-tools{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 13px ;\n}\n\n.message-section .all-message-cards .search-tools .search-bar{\n    background-color: white;\n    width: 280px;\n    border-radius: 23px;\n    padding: 5px 10px;\n}\n\n.message-section .all-message-cards .search-tools .search-bar svg{\n    color: var(--gray-color); \n\n}\n\n.message-section .all-message-cards .search-tools .search-bar input{\n    border: none;\n    width: 210px;\n    margin-left: 8px;\n}\n.message-section .all-message-cards .search-tools .search-bar input:focus{\n    outline: none;\n}\n\n.message-section .all-message-cards .search-tools .btn-send{\n    font-weight: bold;\n    color: white;\n    background-color: var(--main-color);\n    border: none;\n    border-radius: 5px;\n    padding: 12px 18px;\n    cursor: pointer;\n    display: block;\n    font-size: 12px;\n    transition: var(--main-transition);\n}\n\n.message-section .all-message-cards .search-tools .btn-send:hover{\n    opacity: .8;\n}\n\n.message-section .main-pagination{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.message-section .main-pagination .pagination-btn{\n    width: 100px;\n    margin: 10px 0px;\n}\n\n.message-section .main-pagination .pagination-btn button{\n    color: white;\n    background-color: var(--main-color); \n    border-radius: 22px;\n    padding: 10px 22px;\n    border: none;\n}\n\n\n/* End Message */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
